import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import { AvatarComponent } from '@/design-system/atoms/avatar/avatar.component';
import { IconButtonComponent } from '@/design-system/molecules/icon-button/icon-button.component';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-user-card',
  imports: [AvatarComponent, IconButtonComponent, TranslocoPipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './user-card.component.scss',
  templateUrl: './user-card.component.html',
})
export class UserCardComponent {
  readonly username = input.required<string>();
  readonly email = input.required<string>();
  readonly collapsed = input(false);
  readonly logoutClick = output();
}
